import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import agentReducer from './slices/agentSlice';
import sessionReducer from './slices/sessionSlice';

const rootReducer = combineReducers({
  agent: agentReducer,
  session: sessionReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['session'], // Persist session data only; agent resets on login
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
